// utils/upload.js
import apis from '../http/api.js';
import axios from '../http/request.js';

export function uploadFile(file, extraData = {}) {
  const formData = new FormData()
  formData.append('file', file)

  Object.keys(extraData).forEach(key => {
    formData.append(key, extraData[key])
  })

  return axios.post(apis.upload, formData)
}
